<template>
    <a-modal
      :visible="moveToData ? true : false"
      title="Move background"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <a-row>
        <a-col :xs="24" :lg="24">
          <!-- 国家 -->
          <a-form-item>
            <span slot="label">Move <strong>{{ moveToData ? moveToData.enName : '' }}</strong> after</span>
            <a-select
              v-model="moveToCurrentId"
              style="width: 100%;"
              :showSearch="true"
              optionFilterProp="children"
              v-decorator="[
                'background',
                { rules: [{ required: true, message: 'Please select background!' }] },
              ]"
            >
              <a-select-option :value="'top'">Top</a-select-option>
              <a-select-option v-for="i in backgroundList" :key="'background-' + i.id" :value="i.id">{{ i.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <template slot="footer">
          <a-button type="primary" @click="handleOk" :loading="saving">
            Confirm
          </a-button>
      </template>
    </a-modal>
</template>

<script>
import OriginApi from '@/api/dict/api-origin'

export default {
  name: 'OriginMove',
components: {
  },
   props: {
    initData: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      backgroundList: [],
      moveToData: null,
      moveToCurrentId: null,
      saving: false,
    }
  },
  created () {
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.saving = false
      this.moveToCurrentId = 'top'
      this.moveToData = this.initData
      const resBackground = await OriginApi.list()
      const backgroundList = resBackground.data
      this.backgroundList = backgroundList

    },
    async handleOk () {
      this.saving = false
      if (this.moveToCurrentId === 'top') {
        await OriginApi.moveTo(this.moveToData.id)
      } else {
        await OriginApi.moveTo(this.moveToData.id, this.moveToCurrentId)
      }
      this.saving = true
      this.$emit('ok')
    },
    handleCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
    initData () {
      this.loadData()
    }
  }
}
</script>
